import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAllSides: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-all-sides, margin, padding"><path d="M7.75 7.75L16.25 7.75L16.25 16.25H7.75L7.75 7.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M20.25 6C20.25 11.4673 20.25 12.5327 20.25 18" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 6C3.75 11.4673 3.75 12.5327 3.75 18" stroke="currentColor" strokeWidth="1.5"/><path d="M18 3.75L5.99999 3.75" stroke="currentColor" strokeWidth="1.5"/><path d="M18 20.25L5.99999 20.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLayoutAllSides;
